"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { isAiPagePathname } from "../../layout/ai-pathname";
import { useAiSidePanelVisibility } from "../../layout/ai-side-panel-visibility";
import { AnalysisTargetOptionsProvider } from "./analysis-target-options-context";
import { ChatQuotaStatusProvider } from "./chat-quota-status-context";

type AiChatWorkspaceDataProviderProps = {
  children: ReactNode;
  workspaceId: string;
  isAiAvailable?: boolean;
};

/**
 * page と side panel が共有する workspace-scoped AI data の query owner。
 *
 * AI surface が見えている間だけ query を起動し、chatId ごとの thread mount から
 * workspace data の購読ライフサイクルを分離する。
 */
export function AiChatWorkspaceDataProvider({
  children,
  workspaceId,
  isAiAvailable = true,
}: AiChatWorkspaceDataProviderProps) {
  const pathname = usePathname();
  const { isVisible } = useAiSidePanelVisibility();
  const isAiSurfaceActive =
    isAiAvailable && (isAiPagePathname(pathname) || isVisible);

  return (
    <AnalysisTargetOptionsProvider
      workspaceId={workspaceId}
      shouldFetchOptions={isAiSurfaceActive}
    >
      <ChatQuotaStatusProvider
        workspaceId={workspaceId}
        shouldFetchStatus={isAiSurfaceActive}
      >
        {children}
      </ChatQuotaStatusProvider>
    </AnalysisTargetOptionsProvider>
  );
}
